import React from 'react';
import { Building2, ShieldCheck, CalendarClock, Home, Store, Briefcase, Landmark, Users } from 'lucide-react';
import { targetGroups } from '../data/content';

export function WhyClean() {
  return (
    <section className="py-20 md:py-28 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <span className="crown-divider text-[#B8892A]">Warum Pflege zählt</span>
          <h2 className="mt-4 text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#0B1E44] leading-tight">
            Ein gepflegtes Objekt macht den <span className="text-[#DC2626]">ersten Eindruck</span>.
          </h2>
          <p className="mt-5 text-slate-600 text-lg leading-relaxed">
            Verwitterte Fassaden, vermooste Einfahrten oder beschädigte Flächen wirken schnell vernachlässigt. Wir bringen Ihre Immobilie zurück in Form – sichtbar sauber, sichtbar wertvoll.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {[
            { i: Building2, t: 'Gepflegter Eindruck', d: 'Saubere Flächen wirken professionell, ordentlich und einladend – besonders bei Gewerbe- und Wohnobjekten.', c: '#1E3A8A' },
            { i: ShieldCheck, t: 'Werterhalt für Immobilien', d: 'Regelmäßige Reinigung und Sanierung helfen, sichtbare Materialbelastungen frühzeitig zu reduzieren.', c: '#DC2626' },
            { i: CalendarClock, t: 'Planbare Betreuung', d: 'Ob einmalig oder regelmäßig – Arbeiten werden passend zu Objekt, Fläche und Bedarf abgestimmt.', c: '#B8892A' },
          ].map((x, i) => (
            <div key={i} className="group relative bg-white rounded-2xl p-8 card-shadow border border-slate-100 hover:-translate-y-1 transition-transform duration-300">
              <div className="w-14 h-14 rounded-xl flex items-center justify-center text-white mb-6" style={{ background: `linear-gradient(135deg, ${x.c}, ${x.c}CC)` }}>
                <x.i className="w-7 h-7" />
              </div>
              <h3 className="text-xl font-bold text-[#0B1E44]">{x.t}</h3>
              <p className="mt-3 text-slate-600 leading-relaxed">{x.d}</p>
              <div className="mt-6 h-1 w-10 rounded-full" style={{ background: `linear-gradient(90deg, ${x.c}, transparent)` }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const iconFor = (t) => {
  if (t.includes('Hausverwal')) return Building2;
  if (t.includes('Gewerbe')) return Briefcase;
  if (t.includes('Einzelhandel')) return Store;
  if (t.includes('Immobilien')) return Home;
  if (t.includes('Kommun')) return Landmark;
  return Users;
};

export function ForBusiness() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <span className="crown-divider text-[#B8892A]">Für Gewerbe & Verwaltung</span>
          <h2 className="mt-4 text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#0B1E44] leading-tight">
            Ideal für Gewerbe, Hausverwaltungen &<br className="hidden md:block" /> Immobilienbesitzer.
          </h2>
          <p className="mt-5 text-slate-600 text-lg leading-relaxed">
            Bei gewerblichen Immobilien zählt ein gepflegter Zustand jeden Tag. Wir sind der Ansprechpartner für alle, die langfristig Wert auf Ordnung, Pflege und Verlässlichkeit legen.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {targetGroups.map((g, i) => {
            const Icon = iconFor(g.t);
            return (
              <div key={i} className="bg-[#FAF7F2] rounded-2xl p-7 border border-slate-100 hover:border-[#E0A72C]/60 transition-colors duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-lg bg-white border border-slate-200 flex items-center justify-center text-[#1E3A8A]">
                    <Icon className="w-5 h-5" />
                  </div>
                  <div>
                    <h3 className="font-bold text-[#0B1E44] text-lg">{g.t}</h3>
                    <p className="mt-1.5 text-slate-600 text-sm leading-relaxed">{g.d}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
